// Measure vocabulary for the Airbnb review performance table
// (airbnb-review-performance-table AS-12, FR-019). Kept separate from the
// MeasureToggle component so both the toggle and the table (T018) can share the
// type + default without a react-refresh non-component export.

export type MeasureValue = "new-reviews" | "cohort" | "lifetime" | "drift-prev-period" | "drift-prev-year";

// FR-019: when the selected period is a whole year, "previous period" and
// "previous year" denote the same window, so the Drift-vs-Prev-Period segment is
// omitted and Drift-vs-Prev-Year becomes the sensible default.
export function defaultMeasureValue(showPreviousPeriod: boolean): MeasureValue {
    return showPreviousPeriod ? "drift-prev-period" : "drift-prev-year";
}
